import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { QuillModule } from 'ngx-quill';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DataService } from './shared/network/data.service';
import { L10nService } from './shared/l10n.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UploadFileComponent } from './import/upload/upload-file.component';
import { GlobalErrorHandler } from './globalerrorhandler';
import { LoginComponent } from './account/login.component';
import { AccountService } from './shared/account/account-service';
import { DataSanityComponent } from './import/data-sanity/data-sanity.component';
import { ProjectService } from './shared/project/project.service';
import { ReuploadFileComponent } from './import/upload/reupload-file.component';
import { ControlColumnSelectComponent } from './import/column-types/control/control-column-selection.component';
import { OutcomeColumnSelectComponent } from './import/column-types/outcome/outcome-column-selection.component';
import { ExistenceColumnSelectComponent } from './import/column-types/existence/existence-column-selection.component';
import { NotificationService } from './shared/notificaton.service';
import { IdentitiesSelectComponent } from './import/column-types/identities/identities-selection.component';
import { RedundantColumnsSelectComponent } from './import/column-types/redundant/redundant-columns-selection.component';
import { DimensionsColumnsSelectComponent } from './import/column-types/dimensions/dimensions-columns-selection.component';
import { ProjectListComponent } from './projects/project-list.component';
import { PreaggregationStrategySelectComponent } from "./import/preaggregation/preaggregation.component";
import { PreaggregationSevice } from './shared/preaggregation/preaggregation-service';
import { CardsComponent } from './cards/cards.component';
import { HeaderComponent } from './header/header.component';
import { AutoFocusOnShowDirective } from './shared/directives/auto-focus-and-select';
import { RangeSlider } from './range-slider/range-slider.component';
import { DisplayService } from './shared/display-service';
import { ComplexityMgntComponent } from './import/complexity-mgnt/complexity-mgnt.component';
import { ComplexityMngtService } from './shared/complexity-mgnt/complexity-mngt.service';
import { TopValsComponent } from './import/complexity-mgnt/top-vals.component';
import { ImportProgressService } from './shared/import/import-progress.service';
import { ImportNavigatorComponent } from './import/navigator/import-navigator.component';
import { ReferenceSelectComponent } from './import/column-types/reference/reference.component';
import { ConfidenceIconComponent } from './cards/confidence-icon.component';
import { ConfidenceComponent } from './cards/confidence.component';
import { AutofocusDirective } from './autofocus-directive';
import { SignalRService } from './shared/network/signalr.service';
import { HelpLinkComponent } from './shared/help-link/help-link.component';
import { HelpLinkService } from './shared/help-link/help-link.service'
import { BenchmarksComponent } from './benchmarks/benchmarks.component';
import { SeriesComponent } from './import/series/series.component';
import { FancyNumberPipe } from './shared/directives/fancy-number.pipe';
import { HoverClassDirective } from './shared/directives/hover-class.directive';
import { DimensionLabel } from './cards/dimension-label.component';
import { GoogleSettingsService } from './import/upload/google-settings.service';
import { CustomLinkModule } from './shared/quill/quill-custom-link-module';
import { MainFcstWalkComponent } from './cards/main-fcst-walk.component';


@NgModule({
  declarations: [
    AppComponent,
    UploadFileComponent,
    ReuploadFileComponent,
    LoginComponent,
    DataSanityComponent,
    ControlColumnSelectComponent,
    OutcomeColumnSelectComponent,
    ExistenceColumnSelectComponent,
    IdentitiesSelectComponent,
    RedundantColumnsSelectComponent,
    DimensionsColumnsSelectComponent,
    ProjectListComponent,
    PreaggregationStrategySelectComponent,
    CardsComponent,
    HeaderComponent,
    AutoFocusOnShowDirective,
    RangeSlider,
    ComplexityMgntComponent,
    TopValsComponent,
    ImportNavigatorComponent,
    ReferenceSelectComponent,
    ConfidenceIconComponent,
    ConfidenceComponent,
    AutofocusDirective,
    HelpLinkComponent,
    BenchmarksComponent,
    SeriesComponent,
    FancyNumberPipe,
    HoverClassDirective,
    DimensionLabel,
    MainFcstWalkComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    ConfirmationPopoverModule.forRoot({
        confirmButtonType: 'danger', // set defaults here
    }),
    NgxSliderModule,
    MatGridListModule,
    MatInputModule,
    MatSelectModule,
    NgClickOutsideDirective,
    QuillModule.forRoot({customModules: [{
        implementation: CustomLinkModule,
        path: 'modules/customLink'
      }]}),
  ],
  exports: [

  ],
  providers: [
    DataService,
    L10nService,
    NotificationService,
    AccountService,
    ProjectService,
    PreaggregationSevice,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    DisplayService,
    ComplexityMngtService,
    ImportProgressService,
    SignalRService,
    HelpLinkService,
    GoogleSettingsService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
